import ApiService from "./ApiService";

let cachedPromise = null;

/** Drop cache so the next call refetches (e.g. after env / profile switch). */
export function clearTutorFeaturesCache() {
    cachedPromise = null;
}

/**
 * GET /home/sys/features — single-flight cached.
 * @returns {Promise<{ tutorEnable: boolean, supportFrench?: boolean, localProfile?: boolean }>}
 */
export async function getTutorFeatures() {
    if (!cachedPromise) {
        cachedPromise = ApiService.getData("/home/sys/features")
            .then((data) => ({
                tutorEnable: Boolean(data?.tutorEnable),
                supportFrench: Boolean(data?.supportFrench),
                localProfile: Boolean(data?.localProfile),
            }))
            .catch((err) => {
                cachedPromise = null;
                throw err;
            });
    }
    return cachedPromise;
}

/** Resolves tutorEnable; returns false if the features call fails. */
export async function isTutorEnable() {
    try {
        const features = await getTutorFeatures();
        return Boolean(features?.tutorEnable);
    } catch {
        return false;
    }
}
